import type { FaireThemeEntity } from "../../entity_types/theme";

export const rustic_depot_cozy_counter_treats_self_care_caramel_popcorn_soap_candles: FaireThemeEntity =
  {
    token:
      "rustic-depot-cozy-counter-treats-self-care-caramel-popcorn-soap-candles",
    type: "theme",
    retailerToken: "r_464eox2tas",
    name: "Counter Treats",
    description: "Counter display sweets and self-care that drive add-ons",
    bgColor: "#E8D5C4",
    tileBgColor: "#7e7433",
    productTokens: [
      "p_5aeuy9zgag",
      "p_pf2r7fd6ha",
      "p_chg7se2my5",
      "p_s2tjssngx3",
      "p_ng88c4mkn4",
      "p_3fnduwwp45",
      "p_gw7fq4hdtv",
      "p_cm4fj3e19r",
      "p_5z2rf8aan8",
      "p_muspmvda28",
      "p_muvf4pwzbe",
      "p_csq9nhdf5a",
      "p_q6ueeg7gux",
      "p_csbb6vycn7",
      "p_mz8a7uv2tr",
      "p_eskzehpg",
      "p_4pjuakdg8t",
      "p_d9uqn7fy7d",
      "p_ppc4426ckq",
      "p_pd474q2vga",
    ],
    exactProducts: true,
    meta: {
      source: "mock",
      importedAt: "2026-03-24T13:50:10Z",
      importedBy: "retailer-themes-entity-migration",
    },
  };
